import { useEffect } from 'react';

import { CreditStatus } from './utils';

export function useUpdateCreditStatus({
  creditsRemaining,
  creditsUsed,
  storeCreditsOnly,
  setCreditStatus,
  shouldDisplayNoCreditsRemaining,
}) {
  useEffect(() => {
    const hasNoCreditsRemaining =
      creditsRemaining === 0 && shouldDisplayNoCreditsRemaining;

    let newCreditStatus = CreditStatus.available;

    if (hasNoCreditsRemaining) {
      newCreditStatus = CreditStatus.no_credits_remaining;
    }
    if (creditsUsed) {
      newCreditStatus = CreditStatus.applied;
    }

    setCreditStatus(newCreditStatus);
  }, [
    creditsRemaining,
    creditsUsed,
    setCreditStatus,
    shouldDisplayNoCreditsRemaining,
    storeCreditsOnly,
  ]);
}
